/**
 * @generated SignedSource<<587af2e0a8614c94ea993ceb4090befa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRecentSales_buyPageSoldResults$data = {
  readonly items: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_item">;
  } | null> | null;
  readonly " $fragmentType": "SharedRecentSales_buyPageSoldResults";
};
export type SharedRecentSales_buyPageSoldResults$key = {
  readonly " $data"?: SharedRecentSales_buyPageSoldResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_buyPageSoldResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRecentSales_buyPageSoldResults",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 28
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRelatedItemsSection_item"
        }
      ],
      "storageKey": "items(first:28)"
    }
  ],
  "type": "BuyPageSoldResults",
  "abstractKey": null
};

(node as any).hash = "f6f996a4b15b2d28868af3971867c883";

export default node;
